import List from "@/components/list";
import Bus from "../Bus";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function handleDelete({ row }) {
    Bus.$emit("deleteSubject", row);
  }
  function handleUpdate({ row }) {
    Bus.$emit("updateSubject", row);
  }

  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => handleUpdate(vo), "periodicalInfo:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "periodicalInfo:delete"]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "序号",
      type: "index",
      width: "200"
    },
    {
      label: "栏目名称",
      prop: "subjectName"
    },
    {
      label: "操作",
      width: "150",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
